import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import styles from './pagina_brunovitaltattoo.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { INSTAGRAM_URL, MAPS_URL, WHATSAPP_DEFAULT, useBrunoBackground } from './dados_brunovitaltattoo.ts';

import Dep1 from './src/depoimentos/WhatsApp Image 2026-10-30 at 16.45.18.jpeg';
import Dep2 from './src/depoimentos/WhatsApp Image 2026-10-30 at 16.45.46.jpeg';
import Dep3 from './src/depoimentos/WhatsApp Image 2026-10-30 at 16.44.35.jpeg';
import Dep4 from './src/depoimentos/WhatsApp Image 2026-10-30 at 16.46.13.jpeg';
import Dep5 from './src/depoimentos/WhatsApp Image 2026-10-30 at 16.44.13.jpeg';

const DEPOIMENTOS = [
    { src: Dep1, alt: 'Avaliação de Manuela Ferreira da Costa' },
    { src: Dep2, alt: 'Avaliação de Carlos Barros' },
    { src: Dep3, alt: 'Avaliação de Pietra C Martins' },
    { src: Dep4, alt: 'Avaliação de Gleice Nadia Ramos' },
    { src: Dep5, alt: 'Avaliação de Sérgio Quintanilha' },
];

const Depoimentos_brunovitaltattoo: React.FC = () => {
    useBrunoBackground();
    const [aberto, setAberto] = useState(false);
    const [indice, setIndice] = useState(0);
    const toqueX = useRef(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        document.body.style.overflow = aberto ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [aberto]);

    const abrir = (i: number) => {
        setIndice(i);
        setAberto(true);
    };

    const anterior = () => setIndice((atual) => (atual === 0 ? DEPOIMENTOS.length - 1 : atual - 1));
    const proxima = () => setIndice((atual) => (atual === DEPOIMENTOS.length - 1 ? 0 : atual + 1));

    useEffect(() => {
        if (!aberto) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setAberto(false);
            if (e.key === 'ArrowLeft') anterior();
            if (e.key === 'ArrowRight') proxima();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [aberto]);

    return (
        <div className={styles.pagina} lang="pt-BR">
            <div className={styles.header}>
                <Link to="/brunovitaltattoo" className={styles.backButton} aria-label="Voltar">
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.headerTitle}>Depoimentos</h1>
            </div>

            <div className={styles.page}>
                <p className={styles.eyebrow}>Clientes</p>
                <h2 className={styles.name}>O que dizem</h2>

                <div className={styles.depoimentos}>
                    {DEPOIMENTOS.map((item, i) => (
                        <motion.button
                            key={item.src}
                            type="button"
                            className={styles.depoimentoCard}
                            onClick={() => abrir(i)}
                            aria-label={`Abrir ${item.alt}`}
                            initial={{ opacity: 0, y: 14 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.45, delay: (i % 4) * 0.05, ease: [0.22, 1, 0.36, 1] }}
                        >
                            <img src={item.src} alt={item.alt} />
                        </motion.button>
                    ))}
                </div>
            </div>

            <AnimatePresence>
                {aberto ? (
                    <motion.div
                        className={styles.lightbox}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setAberto(false)}
                        onTouchStart={(e) => {
                            toqueX.current = e.changedTouches[0].clientX;
                        }}
                        onTouchEnd={(e) => {
                            const delta = e.changedTouches[0].clientX - toqueX.current;
                            if (delta > 50) anterior();
                            if (delta < -50) proxima();
                        }}
                    >
                        <button
                            type="button"
                            className={`${styles.lightboxBtn} ${styles.closeBtn}`}
                            onClick={() => setAberto(false)}
                            aria-label="Fechar"
                        >
                            <FaTimes />
                        </button>
                        <button
                            type="button"
                            className={`${styles.lightboxBtn} ${styles.prevBtn}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                anterior();
                            }}
                            aria-label="Anterior"
                        >
                            <FaChevronLeft />
                        </button>
                        <motion.img
                            key={DEPOIMENTOS[indice].src}
                            className={styles.lightboxReview}
                            src={DEPOIMENTOS[indice].src}
                            alt={DEPOIMENTOS[indice].alt}
                            initial={{ opacity: 0, scale: 0.98 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.28 }}
                            onClick={(e) => e.stopPropagation()}
                        />
                        <button
                            type="button"
                            className={`${styles.lightboxBtn} ${styles.nextBtn}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                proxima();
                            }}
                            aria-label="Próxima"
                        >
                            <FaChevronRight />
                        </button>
                        <span className={styles.counter}>
                            {indice + 1} / {DEPOIMENTOS.length}
                        </span>
                    </motion.div>
                ) : null}
            </AnimatePresence>

            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href={WHATSAPP_DEFAULT} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <WhatsappIcon height="26" color="#c4a574" />
                        </div>
                        <span>WhatsApp</span>
                    </a>
                    <a href={MAPS_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <MapsIcon height="26" color="#c4a574" />
                        </div>
                        <span>Localização</span>
                    </a>
                    <a href={INSTAGRAM_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <InstagramIcon height="22" color="#c4a574" />
                        </div>
                        <span>Instagram</span>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{' '}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Depoimentos_brunovitaltattoo;
